export const Space = () => {
  return <div className="lg:mt-6 md:mt-4 mt-2" />;
};
